/**
 * 腾讯域：策略配置 × 二级策略 合法映射 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 类型定义在 types/straSecondMapping.types.ts（与后端 Pydantic 对齐），
 * 本文件只保留腾讯域的 HTTP 调用。
 */

import { request } from "../apiClient";
import type {
  StraSecondMappingRecord,
  SaveStraSecondMappingBody,
} from "../../types/straSecondMapping.types";

export async function getLatestMapping(): Promise<StraSecondMappingRecord | null> {
  const data = await request<StraSecondMappingRecord | null>(
    "/api/v1/tencent/stra-second-mapping",
  );
  return data ?? null;
}

export async function saveMapping(
  body: SaveStraSecondMappingBody,
): Promise<StraSecondMappingRecord> {
  return request<StraSecondMappingRecord>("/api/v1/tencent/stra-second-mapping", {
    method: "PUT",
    body,
  });
}
